/* eslint-disable */

/** unique or primary key constraints on table "argo.schedule" */
export enum ArgoScheduleConstraint {
  /** unique or primary key constraint on columns "schedule_id" */
  SchedulePkey = 'schedule_pkey'
}

/** select columns of table "argo.schedule" */
export enum ArgoScheduleSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mode = 'mode',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_schedule_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.schedule" */
export enum ArgoScheduleSelectColumnArgoScheduleAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_schedule_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.schedule" */
export enum ArgoScheduleSelectColumnArgoScheduleAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.schedule" */
export enum ArgoScheduleUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mode = 'mode',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

